import dynamic from "next/dynamic";

export const DynamicLayoutWidget031 = dynamic(
  () => import("./LayoutWidget031"),
  {
    suspense: true,
  }
);
